import SearchStore, { SearchScenarioStore } from './schema/SearchStore';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';

export const createDefaultSearchStore = (): SearchScenarioStore => {
    return {
        isUsing3S: null,
        searchBoxHasFocus: false,
        showRefiners: false,
    };
};

export const searchStore: SearchStore = {
    scenarioStores: new ObservableMap<string, SearchScenarioStore>(),
};

export const getStore = createStore<SearchStore>('commonSearchStoreNext', searchStore);
export default getStore;
